import * as APPROVALSETTINGS from './approvalSettings.constants';
import { ApprovalSettings } from '../../models';

/** LOAD */
export function loadApprovalSettings() {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD };
}

export function loadApprovalSettingsSuccess(data: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD_SUCCESS, payload: data };
}

export function loadApprovalSettingsError(error: any) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addApprovalSettings(targetApprovalSettings: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_ADD, payload: targetApprovalSettings };
}

export function addApprovalSettingsSuccess(targetApprovalSettings: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_ADD_SUCCESS, payload: targetApprovalSettings };
}

export function addApprovalSettingsError(error: any) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateApprovalSettings(targetApprovalSettings: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE, payload: targetApprovalSettings };
}

export function updateApprovalSettingsSuccess(targetApprovalSettings: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE_SUCCESS, payload: targetApprovalSettings };
}

export function updateApprovalSettingsError(error: any) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteApprovalSettings(guids: string[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE, payload: guids };
}

export function deleteApprovalSettingsSuccess(ApprovalSettings: ApprovalSettings[]) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE_SUCCESS, payload: ApprovalSettings };
}

export function deleteApprovalSettingsError(error: any) {
    return { type: APPROVALSETTINGS.APPROVAL_SETTINGS_DELETE_ERROR, payload: error };
}